export default __webpack_public_path__ + "media/verify_blocking_user_account_email/title_locale_fr-7b953476.png";